import React, { useContext } from "react";
import pClasses from "../Home.module.scss";
import RoundButton from "../../../../components/Buttons/RoundButton";
import ButtonsArea from "../../../../components/Buttons/ButtonsArea";
import UserTrainingContext from "../../../../context/userTrainingContext";
import FriendlyInfo from "../../../../components/FriendlyInfo";
import Spinner from "../../../../components/Spinner";
import { useTranslation } from "react-i18next";
import * as r from "../../../../constants/routes";
import { useNavigate } from "react-router";
import { prettySubPathUrl } from "../../../../helpers";

export default function TabTraining() {
  const tContext = useContext(UserTrainingContext);
  const history = useNavigate();
  const { t } = useTranslation();

  let _content = null;
  if (tContext.game_list && tContext.game_list.length > 0) {
    const mapBtn: { [v: string]: any } = {};
    tContext.game_list.forEach((game: any) => {
      if (game.abilities) {
        if (game.abilities[0]) mapBtn[game.abilities[0]] = game.abilities[0];
        if (game.abilities[1]) mapBtn[game.abilities[1]] = game.abilities[1];
      }
    });
    _content = Object.keys(mapBtn).map((category: string) => {
      return (
        <RoundButton
          small
          key={category}
          text={category}
          title={category}
          onClick={() => {
            history(r.GET_R_U_TRAIN_CAT(prettySubPathUrl(category)));
            tContext.setActiveCategory(category);
          }}
        />
      );
    });
    _content = <ButtonsArea vertGo>{_content}</ButtonsArea>;
  } else if (tContext.game_list && tContext.game_list.length === 0) {
    _content = (
      <FriendlyInfo
        isError
        text={t("infos.error_to_fetch_info_try_to_reload")}
      />
    );
  } else {
    _content = <Spinner center />;
  }
  return <section className={pClasses.TabTraining}>{_content}</section>;
}
